var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.557617 10.9999L6.66804 15.8882V12.222H17.6668V9.77782H6.66804V6.11157L0.557617 10.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 4.19922e-05C12.5569 -0.00396485 11.1254 0.278812 9.79034 0.831993C8.45532 1.38517 7.24334 2.19776 6.22461 3.22268L7.95264 4.95071C9.56823 3.33511 11.7167 2.44421 14.002 2.44421C16.2873 2.44421 18.4357 3.33511 20.0513 4.95071C21.6669 6.5663 22.5578 8.71472 22.5578 11C22.5578 13.2853 21.6669 15.4337 20.0513 17.0493C18.4357 18.6649 16.2873 19.5558 14.002 19.5558C11.7167 19.5558 9.56823 18.6649 7.95264 17.0493L6.22461 18.7774C8.30093 20.8549 11.0628 22 14.002 22C16.9411 22 19.703 20.8549 21.7793 18.7774C23.8568 16.701 25.0019 13.9391 25.0019 11C25.0019 8.06091 23.8568 5.299 21.7793 3.22268C20.7606 2.19776 19.5486 1.38517 18.2136 0.831993C16.8785 0.278812 15.447 -0.00396485 14.002 4.19922e-05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.17635aaea1e5513cb0b55255f414b1ae.svg";
export { ForwardRef as ReactComponent };